import api from '../instance';

interface ISendFeedbackData {
  r: number; // survey rating
  i: number; // survey id
  h: string; // survey hash
  c?: string; // survey comment
}

type TSendFeedbackResponse = {
  result: 'success' | 'error';
};

interface ISendFeedbackDemoData {
  i: string; // survey id
  h: string; // survey hash
  q1: number | null; // survey question 1
  c1: string; // survey comment 1
  q2: number | null; // survey question 2
  c2: string; // survey comment 2
}

type TSendFeedbackDemoResponse = {
  ok: boolean;
};

export default {
  sendFeedback: (data: ISendFeedbackData): Promise<TSendFeedbackResponse> =>
    api.post('survey', data),
  sendDemoFeedback: (data: ISendFeedbackDemoData): Promise<TSendFeedbackDemoResponse> =>
    api.post('survey/demo', data),
};
